@if (row) {
  @if ({ serviceIdsToHighlight: serviceIdsToHighlight$ | async }; as data) {
    <div class="d-flex">
      @for (
        service of row.services;
        track trackByActivityIds($index, service)
      ) {
        <wilson-unassigned-item-wrapper
          [item]="service"
          [activityWithOverlapLevel]="
            service.activities | timelineActivitiesOverlapLevels
          "
          [name]="(service.id | getServiceName | async) || ''"
          [isHighlighted]="!!data.serviceIdsToHighlight?.includes(service.id)"
          (click)="openServiceInNewTab(service.id)"
        ></wilson-unassigned-item-wrapper>
      }
    </div>
  }
  <div class="d-flex">
    @for (job of row.jobs; track trackByActivityIds($index, job)) {
      <wilson-unassigned-item-wrapper
        [item]="job"
        [activityWithOverlapLevel]="
          job.activities | timelineActivitiesOverlapLevels
        "
        [name]="(job.id | getJobName | async) || ''"
        (click)="openJobInNewTab(job.id)"
      ></wilson-unassigned-item-wrapper>
    }
  </div>
}
